/**
 * Route Auth0's universal login redirects back to. One source of truth for the
 * app's callback route, the provider's redirect URI, and the `sanitizeReturnTo`
 * guard that rejects it as a return destination (a spent /callback wedges the
 * exchange — legacy redirectToLogin lesson).
 */
export const AUTH_CALLBACK_PATH = '/callback';

/**
 * The app's deliberate login entry point. Like `AUTH_CALLBACK_PATH`, it is a
 * spent route as a `returnTo` destination: `sanitizeReturnTo` rejects it so a
 * crafted `/login?returnTo=/login` can't bounce a freshly-authed user back
 * through the login page instead of to application content.
 */
export const AUTH_LOGIN_PATH = '/login';
